export default __webpack_public_path__ + "static/media/n3-mark-disk.32d1317c.svg";